import React from 'react';
import { CheckCircleIcon } from '../icons/CheckCircleIcon';
import { RevisitIcon } from '../icons/RevisitIcon';

interface SkillStatusBadgeProps {
  status: string;
  className?: string;
  showIcon?: boolean;
  iconType?: 'check-circle' | 'revisit';
}

export const SkillStatusBadge: React.FC<SkillStatusBadgeProps> = ({
  status,
  className = '',
  showIcon = false,
  iconType = 'check-circle',
}) => {
  const renderIcon = () => {
    if (!showIcon) return null;

    switch (iconType) {
      case 'check-circle':
        return <CheckCircleIcon className="tw-ml-1" size={12} />;
      case 'revisit':
        return <RevisitIcon className="tw-ml-1" size={20} />;
      default:
        return null;
    }
  };

  return (
    <span className={className}>
      {iconType === 'revisit' && renderIcon()}
      {status}
      {iconType !== 'revisit' && renderIcon()}
    </span>
  );
};
